var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-between title" },
    [
      _c("v-title", [_vm._v(_vm._s(_vm.item.name))]),
      _vm.item.hasBtn
        ? _c(
            "div",
            { staticClass: "closeDraw" },
            [
              _c("el-button", {
                attrs: { icon: "el-icon-close" },
                on: { click: _vm.handleClose },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }